<template>
  <b-modal id="ModalRecebimentoPg-10146848489"
           centered
           size="xl"
           title="Informações sobre pagamento"
           header-bg-variant="secondary"
           header-text-variant="white">
    <div class="container">
      <div class="parcela">
        <div class="row">
          <label class="mt-4 mb-2 col-12">
            Valor recebido
          </label>
          <input v-model="valorTotal"
                 v-money="money"
                 class="valor-recebido ml-3 col-2 pt-2 pb-2"
                 disabled
                 maxlength="16"
                 size="sm">
          <div class="form-check form-check-inline col-9">
            <b-radio-group :id="`tipo_lancameno_${Math.random()}`"
                           v-model="forma_pg"
                           class="ml-3"
                           :options="optionsPagamento"
                           value-field="item"
                           text-field="name" />
          </div>
        </div>
      </div>
      <div class="pagamento">
        <div class="pagamento-entrada">
          <span>Total</span>
          <span class="pagamento-valor">
            <input v-model="valorTotal"
                   v-money="money"
                   class="text-right"
                   disabled
                   @click="showInfos(item)">
          </span>
        </div>
      </div>
    </div>
    <template slot="modal-footer"
              slot-scope="{ cancel }">
      <button class="btn btn-sm btn-light px-3"
              @click="cancel()">
        Voltar
      </button>
      <button class="btn btn-sm btn-secondary"
              @click="salvarLancamento()">
        Salvar
      </button>
    </template>
  </b-modal>
</template>

<script>
  // Importes
  import { VMoney } from 'v-money'

  // Services
  import pagamentoService from '../../../pagamentoService'

  export default ({
    name: 'ModalRecebimentoPg',
    directives: {
      money: VMoney
    },
    props: {
      propOpenModal: {type: Boolean, default: false},
      propListaPagamento: {type: Array, default: null},
    },
    data () {
      return {
        forma_pg: null,
        valorTotal: 0,
        optionsPagamento: [
          {item: "Dinheiro", name: "Dinheiro"},
          {item: "Cartão de Crédito", name: "Cartão de Crédito"},
          {item: "Cartão de Debito", name: "Cartão de Debito"},
          {item: "Pix", name: "PIX"},
          {item: "Cheque", name: "Cheque"},
          {item: "Outros", name: "Outros"},     
        ],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },
    watch: {
      propOpenModal () {
        if (this.propOpenModal === true) {
          this.$bvModal.show('ModalRecebimentoPg-10146848489')
        }
        this.$bvModal.hide('ModalRecebimentoPg-10146848489')
      },
      propListaPagamento () {
        if (this.propListaPagamento != null) {
          let valor = 0
          this.propListaPagamento.forEach(pedido => {
            valor += pedido.ordemServico.valor_total
          })
          this.valorTotal = valor
        }
      }
    },
    methods: {
      async salvarLancamento () {
        const payload = {
          pedidos: this.propListaPagamento,
          forma_pg: this.forma_pg
        }
        try {
          loader({text: 'Salvando pagamentos', active: true})
          await pagamentoService.storePagamentos(payload)
          this.$emit('atualizarTabela')
          displayMessage('success', 'Pagamentos realizados com sucesso')
        } catch (err) {
          console.log('EditarPagamento', err)
        } finally {
          this.$bvModal.hide('ModalRecebimentoPg-10146848489')
          loader({text: null, active: false})
        }
      },
      validaForm () {

      }
    }
  })
</script>

<style scoped>
.ModalRecebimentoPg {
  z-index: 548484848448489;
  background-color: aqua;
}
</style>
<style scope>
.icon-add-new {
    fill: #1c7af5;
    width: 20px;
    height: 20px;
    transition: fill 0.2s;
    margin-right: 10px;
  }
  #addItens:hover .icon-add-new {
    fill: white;
  }
  .btn-close-modal {
    background-color: #C7C7C7;
    color: black;
    border: none;
  }
  .btn-close-modal:hover {
    background-color: #C7C7C7;
    color: black;
    border: none;
  }
  .parcela {

    padding-bottom: 1rem;
    border-bottom: solid 1px #C7C7C7;
  }
  .parcelas-title {
    font-size: 18px;
  }
  .valor-recebido {
    outline: none;
  }
  .pagamento {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    margin-top: 30px;
    font-size: 20px;
    font-weight: bold;

  }
  .pagamento-entrada {
    display: flex;
    justify-content: space-between;
    background-color: #C7C7C7;
    padding: 10px;
    min-width: 450px;
  }
  .pagamento-troco {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    min-width: 450px;
  }
  .pagamento-valor {
    font-size: 24px;
  }
  .btn-receber {
    background-color: #1A5E38;
    width: 100%;
  }
  .btn-receber-mensalista {
    width: 95%;
  }
</style>
